var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7907 9.9582L16.0247 7.17908L18 7.35012L14.3778 10.4867L15.4483 15.1829L13.7707 14.1636L12.7907 9.9582ZM10.8975 4.09045L9.99791 1.98003L10.7555 0.150146L12.4846 4.23924L10.8975 4.09045ZM5.00578 12.1969L7.80713 10.5072L10.6085 12.2191L9.8748 9.01759L12.3427 6.88323L9.09665 6.5942L7.80713 3.57051L6.51762 6.57197L3.27161 6.86099L5.73947 9.01759L5.00578 12.1969ZM2.98262 14.9862L4.25673 9.49987L0 5.81093L5.61636 5.32354L7.80713 0.150146L9.99791 5.32354L15.6142 5.81093L11.3575 9.49987L12.6316 14.9862L7.80713 12.0755L2.98262 14.9862Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsIcon);
export default __webpack_public_path__ + "static/media/stars-icon.6fec76ae.svg";
export { ForwardRef as ReactComponent };